// Copyright (c) 2025 Deere & Company

import TcsmApproveDenyModal from '../state/tcsm-approve-deny-modal';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const openModal = (state, action) =>
    TcsmApproveDenyModal.update(state, {
        actionToTake: {
            $set: action.actionToTake
        },
        isVisible: {
            $set: true
        }
    });

const closeModal = state =>
    TcsmApproveDenyModal.update(state, {
        $set: getDefaultState().amountOfUseModal
    });

export default (state = getDefaultState().amountOfUseModal, action) => {

    const actionTypes = {
        [actions.CLOSE_TCSM_AMOUNT_OF_USE_MODAL]: closeModal,
        [actions.OPEN_TCSM_AMOUNT_OF_USE_MODAL]: openModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/amount-of-use-modal.js